import { Component, EventEmitter, input } from '@angular/core';

@Component({
  selector: 'vee-page-error-state',
  templateUrl: './page-error-state.component.html',
  styleUrls: ['./page-error-state.component.scss'],
  standalone: false,
})
export class PageErrorStateComponent {
  readonly message = input.required<string>();
  readonly title = input<string>('Fehler beim Laden');
  readonly showRetry = input<boolean>(false);
  readonly retryLabel = input<string>('Erneut versuchen');
  readonly retry = new EventEmitter<void>();
}

